<template>
  <h4
    class="modal-title"
    id="assignaddontitle"
    v-if="
      taskType === 'assignmultiaddons' ||
      taskType === 'assignaddonexclusive' ||
      taskType === 'assignaddonexclusiveusers' ||
      taskType === 'summary' ||
      taskType === 'assignaddonexclusivesummary' ||
      taskType === 'addonExclusiveEmailSent' ||
      taskType === 'emailSent'
    "
  >
    ASSIGN ADD-ON
  </h4>
  <!--Products View-->
  <div
    class="modalbody"
    v-if="
      taskType === 'assignmultiaddons' || taskType === 'assignaddonexclusive'
    "
  >
    <div class="datadiv bottommargin">
      <div class="selected-users-div" v-if="taskType === 'assignmultiaddons'">
        <label class="font-regular-18" data-cy="selected-users-label"
          >Selected users &#40; {{ usersSelectedCount }} &#41;</label
        >
      </div>
      <label class="headerfont"> Available products </label>
      <div class="overflowdiv topmargin" data-cy="products-table">
        <el-table
          id="prodtoassigntable"
          v-loading="loading"
          :data="products"
          :border="true"
          style="width: 100%"
          :row-style="rowdatastyle"
          highlight-current-row
          @current-change="handleCurrentChange"
          :show-header="false"
          empty-text="No assignable products available"
        >
          <!-- :row-class-name="tableRowClassName" -->
          <el-table-column min-width="230">
            <template #default="props">
              <div class="prodnamediv">
                <img
                  src="@/assets/icons/vcicon.svg"
                  class="cellimage"
                  alt="vciconimg"
                  title="vciconimg"
                />
                <div style="text-align: start">
                  <h6
                    class="font-bold"
                    style="font-size: 14px; line-height: 19.07px"
                  >
                    {{ props.row.productName }}
                  </h6>
                  <label>
                    Version:
                    {{ props.row.majorVersionNumber }}.{{
                      props.row.minorVersionNumber
                    }}
                  </label>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <label class="headerfont topmargin" v-if="productSelected">
        Select available add-on
      </label>
      <div
        class="overflowdiv topmargin"
        v-if="productSelected"
        data-cy="addons-table"
      >
        <el-table
          id="prodtoassigntable"
          ref="multipleTableRef"
          v-loading="addonLoading"
          :data="addons"
          :border="true"
          style="width: 100%"
          :row-style="rowdatastyle"
          :row-class-name="tableRowClassName"
          :cell-class-name="disableCellWithSeatsUsed"
          @selection-change="handleSelectedAddOns"
          :show-header="false"
          empty-text="No assignable add-ons available"
        >
          <!-- :row-class-name="tableRowClassName" -->
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column min-width="230">
            <template #default="props">
              <el-tooltip
                placement="top"
                v-if="
                  usersSelectedCount > props.row.seats - props.row.seatsUsed
                "
              >
                <template #content
                  >The add-on has less seats than the selected users
                </template>
                <div class="prodnamediv">
                  <img
                    src="@/assets/icons/addonicon.svg"
                    class="cellimage"
                    alt="addoniconimg"
                    title="addoniconimg"
                  />
                  <div style="text-align: start">
                    <h6
                      class="font-bold"
                      style="font-size: 14px; line-height: 19.07px"
                    >
                      {{ props.row.productName }}
                    </h6>
                    <label>
                      Version:
                      {{ props.row.majorVersionNumber }}.{{
                        props.row.minorVersionNumber
                      }}
                    </label>
                  </div>
                </div>
              </el-tooltip>
              <div
                class="prodnamediv"
                v-if="
                  usersSelectedCount <= props.row.seats - props.row.seatsUsed
                "
              >
                <img
                  src="@/assets/icons/addonicon.svg"
                  class="cellimage"
                  alt="addoniconimg"
                  title="addoniconimg"
                />
                <div style="text-align: start">
                  <h6
                    class="font-bold"
                    style="font-size: 14px; line-height: 19.07px"
                  >
                    {{ props.row.productName }}
                  </h6>
                  <label>
                    Version:
                    {{ props.row.majorVersionNumber }}.{{
                      props.row.minorVersionNumber
                    }}
                  </label>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #default="props">
              <div
                :class="
                  usersSelectedCount > props.row.seats - props.row.seatsUsed
                    ? 'less-seats-label'
                    : 'font-bold-16'
                "
              >
                {{ props.row.seatsUsed }}&#47;{{ props.row.seats }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="buttonsdiv">
      <el-button
        id="assignaddonnext"
        round
        class="btnstyle ml-4"
        variant="warning"
        @click="nextHandler"
        :disabled="!showNext"
        data-cy="addons-button-next"
      >
        Next
      </el-button>
      <el-button
        id="prodassigncancel"
        round
        variant="outline-dark"
        @click="cancelInvite"
        class="cancelbtn"
        data-cy="addons-button-cancel"
        >Cancel</el-button
      >
    </div>
  </div>
  <!--User Selection for Assign Addon Exclusive view only-->
  <AssignAddonUsersModal
    v-if="taskType === 'assignaddonexclusiveusers'"
    :selectedAddOns="selectedAddons"
  />
  <!--Summary View-->
  <div
    v-if="taskType === 'summary' || taskType === 'assignaddonexclusivesummary'"
    class="modalbody"
    v-loading="loading"
  >
    <AddonSummaryModal
      :assignedProduct="selectedProduct"
      dataof="product"
      :selectedAddonList="selectedAddons"
    />
    <div v-if="showError" style="display: flex" class="maxitems">
      <img
        src="@/assets/icons/warnerror.svg"
        class="cellimage"
        style="margin-top: 10px"
        alt="erroriconimg"
        title="erroriconimg"
      />
      <label
        class="errordiv"
        v-if="addUserError !== ''"
        style="padding: 1rem 0"
      >
        {{ addUserError }}</label
      >
    </div>
    <div class="buttonsdiv">
      <el-button
        round
        class="btnstyle ml-4"
        variant="warning"
        id="prodassingconfirm"
        @click="sendInvite"
        :disabled="!enableControls"
        data-cy="addons-button-next"
      >
        <i v-if="!enableControls" class="fa fa-refresh fa-spin"></i>
        Confirm
      </el-button>
      <el-button
        round
        class="btnstyle ml-4"
        variant="warning"
        id="backbutton"
        @click="backClickHandler"
        data-cy="addons-button-back"
      >
        Back
      </el-button>
      <el-button
        id="prodassigncancel"
        round
        variant="outline-dark"
        @click="cancelInvite"
        class="cancelbtn"
        data-cy="addons-button-cancel"
        >Cancel</el-button
      >
    </div>
  </div>
  <!--Results view for Assign Addon Exclusive Email Sent-->
  <div v-if="taskType == 'addonExclusiveEmailSent'" class="modalbody">
    <AssignAddonsResultModal
      :selectedAddons="selectedAddons"
      :assignAddonsResult="assignAddonResult"
    />
    <div class="buttonsdiv">
      <el-button
        id="prodassigncancel"
        round
        variant="outline-dark"
        @click="cancelInvite"
        class="btnstyle"
        data-cy="addons-button-cancel"
        >Done</el-button
      >
    </div>
  </div>
  <!--Results view for Assign Addon Email Sent-->
  <div v-if="taskType === 'emailSent'" class="modalbody">
    <div class="innerModal">
      <img
        src="@/assets/icons/mailsent.svg"
        style="width: 70px; margin-bottom: 1rem"
        alt="mailsenticonimg"
        title="mailsenticonimg"
      />
      <label class="labelbld">Notification email sent to: </label>
      <div
        v-for="(addon, index) in selectedAddons"
        :key="index"
        class="addonlistdiv"
      >
        <label class="font-regular-16 btm-1">
          Add-on "<strong>{{ addon.productName }}</strong
          >" has been assigned and notification email sent to users
        </label>
        <div class="userlistdiv">
          <div v-for="(item, index) in selectedUsers" :key="index">
            <!-- <p style="margin: 0"> -->
            <label v-if="item.userName" class="font-regular-16 breaking-words">
              {{ item.userName }}&#44;
              {{ item.email }}
            </label>
            <label v-else class="font-regular-16 breaking-words">
              {{ item.firstName }}&#44; {{ item.lastName }}&#44;
              {{ item.email }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonsdiv">
      <el-button
        id="prodassigndone"
        round
        class="btnstyle"
        variant="warning"
        @click="cancelInvite"
        style="float: right"
      >
        Done</el-button
      >
    </div>
  </div>
</template>

<style lang="scss">
.selectedusersdiv {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.el-table .disable-addon-row {
  background: #e7e7e7;
  border: 1px solid #e7e7e7;
}
.el-table .disable-addon-row {
  background-color: rgba(172, 179, 180, 0.5);
  cursor: not-allowed;
}
.el-table .disabled-cell {
  cursor: not-allowed;
}
.el-table .disable-addon-row .el-checkbox__input .el-checkbox__inner {
  cursor: not-allowed;
  background-color: rgba(172, 179, 180, 0.5);
  border-color: rgba(172, 179, 180, 0.5);
}
.datadisplaydiv {
  display: flex;
  flex-direction: column;
}
</style>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { mapGetters } from "vuex";
import APIService from "@/utils/APIService";
import {
  ApiAssignEntitlementsToUsersResponse,
  ProductInfomation,
} from "@/utils/AppInterfaces";
import _ from "lodash";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { ProductActionTypes } from "@/store/productstore/ProductActionTypes";
import AddonSummaryModal from "./AddonSummaryModal.vue";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";
import AssignAddonUsersModal from "./AssignAddonUsersModal.vue";
import AssignAddonsResultModal from "./AssignAddonsResultModal.vue";

export default defineComponent({
  name: "AssignMultipleAddonsModal",
  components: {
    AddonSummaryModal,
    AssignAddonUsersModal,
    AssignAddonsResultModal,
  },
  computed: {
    ...mapGetters([
      "getAvailableProducts",
      "getUserData",
      "getSelectedUsers",
      "getTaskType",
      "getCompanyData",
      "getCurrentUser",
      "getAddonsList",
      "getSearchValue",
      "getCurrentPage",
    ]),
    products() {
      return this.intersectionList || this.getAvailableProducts?.items || [];
    },
    usersSelectedCount(): number {
      return this.getSelectedUsers.length || 0;
    },
    addons(): any {
      if (
        this.productSelected &&
        this.getAddonsList.length === 0 &&
        this.addonLoading
      )
        this.getSubscriptionAvailableAddOns();
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      else this.addonLoading = false;
      return this.getAddonsList;
    },
    selectedUsers(): any {
      return this.getSelectedUsers.length !== undefined
        ? this.getSelectedUsers
        : [this.getUserData];
    },
    taskType(): any {
      return this.getTaskType;
    },
    showNext(): any {
      return (
        !_.isEmpty(this.selectedProduct) && !_.isEmpty(this.selectedAddons)
      );
    },
  },
  data() {
    return {
      selectedProduct: {} as unknown as ProductInfomation,
      userdetails: this.userData,
      enableControls: true,
      currentRow: null as unknown as ProductInfomation,
      showError: false,
      addUserError: "",
      rowdatastyle: {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "400",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      productsLoaded: false,
      loading: true,
      productSelected: false,
      addonLoading: true,
      selectedAddons: [] as ProductInfomation[],
      errorUsers: [],
      companyBucketId: "",
      assignAddonResult: {} as ApiAssignEntitlementsToUsersResponse,
    };
  },
  methods: {
    tableRowClassName({ row }: { row: ProductInfomation }) {
      if (this.getSelectedUsers.length > row.seats - row.seatsUsed) {
        return "disable-addon-row";
      }
      return "";
    },
    disableCellWithSeatsUsed({
      row,
      columnIndex,
    }: {
      row: any;
      columnIndex: number;
    }) {
      if (
        this.getSelectedUsers.length > row.seats - row.seatsUsed &&
        columnIndex === 0
      ) {
        return "disabled-cell";
      }
      return "";
    },
    getAvailableProductsList() {
      this.productsLoaded = false;
      this.loading = true;
      switch (this.$route.name) {
        case "account":
          this.companyBucketId = this.getCurrentUser.result.companyBucketId;
          break;
        case "companies":
          this.companyBucketId = this.getCompanyData.companyBucketId;
          break;
        case "user":
          this.companyBucketId = this.getUserData.companyBucketId;
          break;
        default:
      }
      const apiService = new APIService(this.axios);
      const companyDataObj = {
        companyBucketIdCollection: [this.companyBucketId],
        pageOptions: {
          skip: 0,
          take: 50,
        },
      };
      apiService
        .getAddonsAvailableProducts(companyDataObj)
        .then((res) => {
          this.$store.dispatch(ProductActionTypes.SET_AVAILABLE_PRODUCTS, res);
          this.productsLoaded = true;
          this.loading = false;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    getSubscriptionAvailableAddOns() {
      const mainProductInfomation = {
        mainProductBucketId: this.selectedProduct.productBucketId,
        mainProductMajorVersion: this.selectedProduct.majorVersionNumber,
        mainProductMinorVersion: this.selectedProduct.minorVersionNumber,
        companyBucketIdList: [
          this.selectedProduct.companyBucketId ?? this.companyBucketId,
        ],
      };
      const apiService = new APIService(this.axios);
      this.addonLoading = true;
      apiService
        .getSubscriptionAddonsList(mainProductInfomation)
        .then((res) => {
          this.$store.dispatch(ProductActionTypes.SET_ADDONS_LIST, res.items);
          this.productsLoaded = true;
          this.addonLoading = false;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    nextHandler() {
      if (this.taskType === "assignaddonexclusive") {
        this.$store.dispatch(
          FlowActionTypes.SET_TASK_TYPE,
          "assignaddonexclusiveusers"
        );
      } else {
        this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "summary");
      }
    },
    backClickHandler() {
      if (this.taskType === "assignaddonexclusivesummary")
        this.$store.dispatch(
          FlowActionTypes.SET_TASK_TYPE,
          "assignaddonexclusiveusers"
        );
      else
        this.$store.dispatch(
          FlowActionTypes.SET_TASK_TYPE,
          "assignmultiaddons"
        );
    },
    nextClickHandler() {
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "account");
    },
    handleCurrentChange(val: ProductInfomation) {
      this.$store.dispatch(FlowActionTypes.SET_PRODUCT_DATA, val);
      this.selectedProduct = val;
      this.productSelected = true;
      this.getSubscriptionAvailableAddOns();
    },
    handleSelectedAddOns(selected: any) {
      this.selectedAddons = selected;
    },
    sendInvite() {
      this.loading = true;
      this.enableControls = false;
      var addOnsList: any[] = [];

      const apiService = new APIService(this.axios);
      const multipleRequestData: any[] = [];
      this.selectedAddons.map((item: any) => {
        addOnsList.push({
          productBucketId: item.productBucketId,
          major: item.majorVersionNumber,
          minor: item.minorVersionNumber,
        });
      });
      this.selectedUsers.map((user: any) => {
        var addonsForUser = [...addOnsList];
        user.addOns.map((itemIndex: any) => {
          if (
            _.some(this.selectedAddons, {
              productBucketId: itemIndex.productBucketId,
            })
          )
            _.remove(addonsForUser, {
              productBucketId: itemIndex.productBucketId,
            });
        });
        const inviteObj = {
          companyBucketId: this.selectedProduct.companyBucketId,
          userBucketId: user.userBucketId,
          entitlementsToAssign: addonsForUser,
        };
        multipleRequestData.push(inviteObj);
      });
      if (addOnsList.length !== 0) {
        apiService
          .assignMultipleSubscription(multipleRequestData)
          .then((res) => {
            this.loading = false;
            this.assignAddonResult = res;
            if (this.taskType === "assignaddonexclusivesummary") {
              this.$store.dispatch(
                FlowActionTypes.SET_TASK_TYPE,
                "addonExclusiveEmailSent"
              );
            } else if (res.areAllSuccessfull) {
              this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "emailSent");
            } else {
              res.responses.map((dataItem: any) => {
                if (dataItem.areAllSuccessfull) console.log(dataItem);
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.code === "ECONNABORTED")
              this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
          });
      } else {
        this.showError = true;
        this.addUserError =
          "Selected users already have the selected add-ons assigned!";
      }
      return !this.enableControls;
    },
    cancelInvite() {
      /*  const apiService = new APIService(this.axios);
      const userDataObj = {
        userBucketIdList: null,
        companyBucketIdList: null,
        searchPhrase: this.getSearchValue,
        companyName: null,
        pageOptions: {
          skip: this.getCurrentPage - 1,
          take: 10,
          sortField: null,
          sortOrder: null,
        },
      };
      apiService
        .getUsersList(userDataObj)
        .then((res) => {
          this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, res);
          this.loading = false;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });*/
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, false);
      this.$store.dispatch(ProductActionTypes.SET_ADDONS_LIST, []);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_EMAILS, []);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERS, []);
      this.$store.dispatch(FlowActionTypes.SET_PRODUCT_DATA, {});
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "none");
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ASSIGNADDON, false);
      this.$store.dispatch(
        FlowActionTypes.SET_SHOW_ASSIGNADDON_EXCLUSIVE,
        false
      );
    },
  },
  mounted() {
    if (this.taskType === "assignaddonexclusive")
      this.getAvailableProductsList();
    else {
      this.loading = false;
    }
  },
  props: {
    intersectionList: {
      type: Array as PropType<ProductInfomation[]>,
      required: false,
    },
  },
});
</script>
